module.exports = __webpack_public_path__ + "static/media/facebook.8c89ef8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facebook.png
// module id = 344
// module chunks = 0 1 2